<div>
  <i
    (click)="returnHome()"
    class="fa-solid fa-circle-arrow-left float-start back-icon"
    title="Back to Manage Commissions Page">
  </i>
</div>
<div class="page-header-bar">
  <section class="state-commission">
    <h2>State Commission for {{selectedState.name}}:</h2>
  </section>
</div>
<div class="subheader-text">
  Requirements vary by state. Upload your signature, stamp, and digital certificate with the required key information (Digital Signature, Non-Repudiation). Use certificates from trusted providers like IdenTrust, ensure the file is in PFX format, and check for a valid expiration date.
</div>
@if (!((selectedRule | async)?.isCommissionDeleteDisabled) && (this.commissionId || this.sassGuid)) {
  <button class="btn-secondary float-end" type="button" (click)="deleteCommission()">
    Delete Commission
  </button>
}
<div class="active-commission-header">
  @if (hasCommission | async) {
    <h3>Active Commission</h3>
  }
  @if (hasCommission | async) {
    <div class="commission-subtext">This is your active commission. Click "Edit" to see more details or to customize.</div>
  }
</div>
@if (hasCommission | async) {
  <div>
    @if (selectedCommission | async; as commission) {
      <div class="active-commission">
        <mat-card>
          @if (commission.stamp) {
            <mat-card-header >
              <section class="image-section">
                <img [src]="getSanitizedImage(commission.stamp)"
                  class="stamp-image"
                  alt="Notary Seal for {{ selectedState.name }}" />
                </section>
              </mat-card-header>
            }
            <mat-card-content>
              <div class="headline">
                <span class="bold">Active Commission</span>
              </div>
              @if ((selectedRule | async)?.isCommissionNumberRequired) {
                <div class="body">Commission Number: {{ commission.number }}</div>
              }
              <div class="body">County: {{ commission.county }}</div>
              <div class="body">
                @if (isCommissionExpired) {
                  <span><i class="fa-solid fa-triangle-exclamation needs-attention"></i>&nbsp;</span>
                }
                Expires: {{ commission.expiresOn | date: "MM/dd/yyyy" }}
              </div>
              <div class="body">
                <strong>Commission Status:</strong><br>
                {{ isCommissionExpired ? 'Expired' : (commission.statusCode || 'Unknown') }}
              </div>
              @if (commission.statusCodeValidationFailures?.length) {
                <div class="body">
                  <strong>Validation Issues:</strong>
                  <ul style="list-style-type: none; padding-left: 0;">
                    @for (failure of commission.statusCodeValidationFailures; track failure) {
                      <li>
                        {{ validationMessages[failure] || failure }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </mat-card-content>
            @if (!((selectedRule | async)?.isCommissionUpdateDisabled)) {
              <mat-card-footer>
                <mat-card-actions align="end">
                  <button (click)="openCommissionModal('edit')"
                    class="btn-primary">
                    Edit
                  </button>
                </mat-card-actions>
              </mat-card-footer>
            }
          </mat-card>
          @if (primaryStamp || ipenStamp || ronStamp) {
            <mat-card>
              <mat-card-content>
                @if (primaryStamp) {
                  <section>
                    <div class="headline">
                      <span class="bold left">Stamp</span>
                    </div>
                    <img [src]="getSanitizedImage(primaryStamp?.base64String)"
                      class="image-section stamp-image"
                      alt="Notary Seal for {{ selectedState.name }}" />
                    </section>
                  }
                  @if (ronStamp) {
                    <section>
                      <div class="headline">
                        <span class="bold left">RON Stamp</span>
                      </div>
                      <img [src]="getSanitizedImage(ronStamp?.base64String)"
                        class="image-section stamp-image"
                        alt="Notary Seal for {{ selectedState.name }}" />
                      </section>
                    }
                    @if (primaryStamp && ipenStamp) {
                      <hr class="stamp-divider">
                    }
                    @if (ipenStamp) {
                      <section>
                        <div class="headline">
                          <span class="bold left">IPEN Stamp</span>
                        </div>
                        <img [src]="getSanitizedImage(ipenStamp?.base64String)"
                          class="stamp-image image-section"
                          alt="Notary Seal for {{ selectedState.name }}" />
                        </section>
                      }
                    </mat-card-content>
                  </mat-card>
                }
                @if (ruleLoaded | async) {
                  <div>
                    @if ((selectedRule | async)?.isSignatureUploadEnabled || (selectedRule | async)?.isAutoGeneratedSignatureAllowed) {
                      <div>
                        @if (commission.signature) {
                          <mat-card>
                            <mat-card-header>
                              <section class="image-section">
                                <img [src]="getSanitizedImage(commission.signature)"
                                  class="signature-image"
                                  alt="Notary Signature for {{ selectedState.name }}" />
                                </section>
                              </mat-card-header>
                              <mat-card-content>
                                <div class="headline">
                                  <span class="bold">Signature</span>
                                </div>
                                <div class="body">This is your current active signature</div>
                              </mat-card-content>
                              @if ((selectedRule | async)?.isSignatureUploadEnabled) {
                                <mat-card-footer>
                                  <mat-card-actions align="end">
                                    <button (click)="openSignatureModal('edit')"
                                      class="btn-primary edit-button"
                                      title="If disabled, please update the commission expiration date first."
                                      [disabled]="isCommissionExpired">
                                      Edit
                                    </button>
                                  </mat-card-actions>
                                </mat-card-footer>
                              }
                            </mat-card>
                          }
                          @if (!commission.signature) {
                            <mat-card>
                              <mat-card-content>
                                <div class="headline">
                                  <span class="bold">
                                    <i class="fa-solid fa-triangle-exclamation missing-upload"></i>
                                    No Active Signature
                                  </span>
                                </div>
                                <div class="body">Add a signature to complete your commission.</div>
                              </mat-card-content>
                              <mat-card-footer>
                                <mat-card-actions align="end">
                                  <button class="btn-primary"
                                    (click)="openSignatureModal('add')"
                                    title="If disabled, please update the commission expiration date first."
                                    [disabled]="isCommissionExpired">
                                    + Add Signature
                                  </button>
                                </mat-card-actions>
                              </mat-card-footer>
                            </mat-card>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (ruleLoaded | async) {
                    <div>
                      @if ((selectedRule | async)?.isCertificateUploadEnabled) {
                        <div>
                          @if (hasActiveCertificate(commission)) {
                            <mat-card>
                              <mat-card-content>
                                <div class="headline">
                                  <span class="bold">Active Digital Certificate</span>
                                </div>
                                <section>
                                  <span class="fas fa-check primary-color-txt ms-1"></span>
                                </section>
                              </mat-card-content>
                              <mat-card-footer>
                                <mat-card-actions align="end">
                                  <button (click)="openCertificateModal('edit')"
                                    class="btn-primary edit-button"
                                    title="If disabled, please update the commission expiration date first."
                                    [disabled]="isCommissionExpired">
                                    Replace
                                  </button>
                                </mat-card-actions>
                              </mat-card-footer>
                            </mat-card>
                          }
                          @if (!hasActiveCertificate(commission)) {
                            <mat-card>
                              <mat-card-content>
                                <div class="headline">
                                  <span class="bold">
                                    <i class="fa-solid fa-triangle-exclamation missing-upload"></i>
                                    No Active Certificate
                                  </span>
                                </div>
                                <div class="body">Add a certificate to complete your commission.</div>
                              </mat-card-content>
                              <mat-card-footer>
                                <mat-card-actions align="end">
                                  <button class="btn-primary"
                                    (click)="openCertificateModal(selectedCommission, 'add')"
                                    title="If disabled, please update the commission expiration date first."
                                    [disabled]="isCommissionExpired">
                                    + Add Certificate
                                  </button>
                                </mat-card-actions>
                              </mat-card-footer>
                            </mat-card>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
